import MiniCart from './MiniCart';

export default MiniCart;
